import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../Layout/Layout";
import LineChart from "./Charts/LineChart";
import AreaChart from "./Charts/AreaChart";
import SuppliersColumnChart from "./Charts/SuppliersColumnChart";
import POColumnChart from "./Charts/POColumnChart";
import BarChart from "./Charts/BarChart";
import PieChart from "./Charts/PieChart";
import DonutChart from "./Charts/DonutChart";
import { useNavigate } from "react-router-dom";

//Serivce
import ItemService from "../../services/supplier_appCommonService";
import LoaderSmall from "../../Components/LoaderSmall";
import { getCurrentDate } from "../../common/Validations";
import DatePickerComponent from "./Charts/FilterComponent/DatePickerComponent";
import SupplierConstants from "../../common/SupplierConstants";
import CategoryCard from "../../Components/Cards/CategoryCard";
import { FileSpreadsheet, FileText, Package } from "lucide-react";
import PurchaseRequisitionChart from "./Charts/PurchaseRequisitionChart";
import RfxColumnChart from "./Charts/RfxColumnChart";
import HorizontalStatusBarChart from "../../Components/HorizontalStatusBarChart";
import ItemService2 from "../../services/customer_appCommonService";
import CollapseCard from "../../Components/Collapsecard/Collapsecard";

const Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  const navigateToMainPage = (page) => {
    if (page === "supplier") {
      navigate(SupplierConstants.SUPPILER_LIST);
    } else if (page === "users") {
      navigate(SupplierConstants.ADMIN_MANAGE_USER_LIST);
    } else if (page === "pr") {
      navigate(SupplierConstants.SOURCING_PURCHASE_REQUISITION_LIST);
    } else if (page === "po") {
      navigate(SupplierConstants.POCOLLABRATION_PURCHASE_ORDER_LIST);
    } else if (page === "qtn") {
      navigate(SupplierConstants.SOURCING_BUYER_QUOTATION_LIST);
    }
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

  const [filterShow, setFilterShow] = useState(false);
  // eslint-disable-next-line
  const [totalUserCount, setTotalUserCount] = useState("");
  // eslint-disable-next-line
  const [totalUserCountStatus, setTotalUserCountStatus] = useState(false);
  // eslint-disable-next-line
  const [supplierCount, setSupplierCount] = useState("");
  // eslint-disable-next-line
  const [supplierCountStatus, setSupplierCountStatus] = useState(false);

  // eslint-disable-next-line
  const [poCount, setPoCount] = useState("");
  // eslint-disable-next-line
  const [poCountStatus, setPoCountStatus] = useState(false);
  // eslint-disable-next-line
  const [prCount, setPrCount] = useState("");
  // eslint-disable-next-line
  const [prCountStatus, setPrCountStatus] = useState(false);

  const [supplierStatusColChart, setSupplierStatusColChart] = useState("");
  const [supplierStatusColChartStatus, setSupplierStatusColChartStatus] =
    useState(false);

  const [poStatusColChart, setPOStatusColChart] = useState("");
  const [poStatusColChartStatus, setPOStatusColChartStatus] = useState(false);

  console.log(poStatusColChart);

  const [prChartLoading, setPrChartLoading] = useState(true);
  const [prChartData, setPrChartData] = useState({
    categories: [],
    series: [],
  });
  const [loading, setLoading] = useState(true);

  const Pr = async (filter) => {
    setPrChartLoading(true);

    const obj = {
      ...filter,
      module: "po",
      chartType: "column",
      timeZone: "Asia/Calcutta",
      queryName: "Yearly_PR_Chart",
    };

    try {
      const item = await ItemService.dashboard(obj);

      if (item?.status === 200 || item?.data?.status === true) {
        const api = item?.data?.data || item?.data; // auto-detect correct structure

        const categories = api?.categories || [];
        const rows = api?.getQueryResponse || [];

        const series = [
          { name: "PR Approved", data: new Array(categories.length).fill(0) },
          { name: "In Release", data: new Array(categories.length).fill(0) },
          { name: "Cancelled", data: new Array(categories.length).fill(0) },
        ];

        rows.forEach((row) => {
          const index = (row.name || 0) - 1;
          const target = series.find((x) => x.name === row.status);
          if (target) target.data[index] = row.count;
        });

        setPrChartData({ categories, series });
      } else {
        toast.error("PR Chart loading failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching PR chart");
    }

    setPrChartLoading(false);
  };

  useEffect(() => {
    Pr();
  }, []);

  const [chartData, setChartData] = useState({
    categories: [],
    series: [],
  });

  const loadRfxChart = async (filter = {}) => {
    setLoading(true);

    const obj = {
      ...filter,
      module: "po",
      chartType: "column",
      timeZone: "Asia/Calcutta",
      queryName: "Yearly_RFX_Chart",
    };

    try {
      const item = await ItemService.dashboard(obj);

      if (item?.status === 200 || item?.data?.status === true) {
        const api = item?.data?.data || item?.data;

        const categories = api?.categories || [];
        const rows = api?.getQueryResponse || [];

        const statusList = [
          "RFQ Created",
          "Published",
          "QTN Received",
          "Technical Open",
          "Tech Approved",
          "Commercial Open",
          "Commercial Approved",
        ];

        const series = statusList.map((name) => ({
          name,
          data: new Array(categories.length).fill(0),
        }));

        rows.forEach((row) => {
          const index = (row.name || 0) - 1;
          const target = series.find((s) => s.name === row.status);
          if (target) target.data[index] = row.count;
        });

        setChartData({ categories, series });
      } else {
        toast.error("Failed to load RFX Chart");
      }
    } catch (e) {
      console.error(e);
      toast.error("RFX Chart API Error");
    }

    setLoading(false);
  };

  useEffect(() => {
    loadRfxChart();
  }, []);

  // PR COUNT
  const loadPRCount = async () => {
    setPrCountStatus(true);
    let obj = {};

    await ItemService.prCount(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setPrCount(item.data[0]);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setPrCountStatus(false);
  };

  // PO COUNT
  const loadPOCount = async () => {
    setPoCountStatus(true);
    let obj = {};

    await ItemService.poCount(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setPoCount(item.data[0]);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setPoCountStatus(false);
  };

  // Supplier Count
  const loadSupplierCount = async () => {
    setSupplierCountStatus(true);
    let obj = {};

    await ItemService.supplierCount(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setSupplierCount(item.data[0]);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setSupplierCountStatus(false);
  };

  // User Count
  const loadTotalUserCount = async () => {
    setTotalUserCountStatus(true);
    let obj = {};

    await ItemService.totalUserCount(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalUserCount(item.data[0]);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalUserCountStatus(false);
  };

  // Suppliers Chart
  const suppliersChart = async (filterData) => {
    setSupplierStatusColChartStatus(true);
    filterData.module = "supplier";
    filterData.chartType = "column";

    await ItemService.dashboard(filterData).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        item.data.module = "supplier";
        setSupplierStatusColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setSupplierStatusColChartStatus(false);
  };

  // PO Chart
  const poChart = async (filterData) => {
    setPOStatusColChartStatus(true);
    filterData.module = "po";
    filterData.chartType = "pie";

    await ItemService.dashboard(filterData).then((item) => {
      if (item?.status === 200) {
        item.data.module = "po";
        setPOStatusColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setPOStatusColChartStatus(false);
  };

  // On Filtered Data
  const handleFilterData = async (filter) => {
    // console.log(">> filter", filter);

    await suppliersChart(filter);
    await poChart(filter);
    await loadRfxChart(filter);
    await Pr(filter);
  };

  useEffect(() => {
    let defaultFilter = {
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
    };

    loadPRCount();
    loadPOCount();
    loadSupplierCount();
    loadTotalUserCount();

    suppliersChart(defaultFilter);
    poChart(defaultFilter);
    loadRfxChart(defaultFilter);
    Pr(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const categoryConfigs = [
    {
      title: "Purchase Requisition",
      queryName: "Get_PR_Count_value",
      icon: FileText,
      navigateKey: "pr",
    },
    {
      title: "Request For Quotation",
      queryName: "Get_Quotation_Count_value",
      icon: Package,
      navigateKey: "qtn",
    },
    {
      title: "Purchase Order",
      queryName: "Get_PO_Count_value",
      icon: FileSpreadsheet,
      navigateKey: "po",
    },
    {
      title: "Invoice",
      queryName: "Get_INV_Count_value",
      icon: "bi bi-currency-dollar",
    },
    {
      title: "Supplier",
      // queryName: "Get_PO_Count_value",
      fetchFunction: ItemService.supplierCount,
      icon: "bi bi-people",
      navigateKey: "supplier",
    },
    {
      title: "Total Users",
      icon: "bi bi-people",
      navigateKey: "users",
      fetchFunction: ItemService.totalUserCount, // CUSTOM API
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Dashboard detailed page</p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            {filterShow && (
              <DatePickerComponent
                getfiltereddata={handleFilterData}
                cancelAction={() => setFilterShow(!filterShow)}
              />
            )}

            <section className="section">
              <section className="section">
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="">
                    {/* <h5 className="card-title mb-3">My Category</h5> */}
                    <div className="row g-3">
                      {categoryConfigs.map((item, index) => (
                        <div
                          className="col-12 col-md-6 col-lg-3 px-2"
                          key={index}
                        >
                          <CategoryCard
                            {...item}
                            onClick={() => navigateToMainPage(item.navigateKey)}
                          />
                        </div>
                      ))}
                    </div>
                  </CollapseCard>
                </div>
              </section>

              <div className="row">
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="">
                    <HorizontalStatusBarChart
                      api={ItemService2.generateCustomerQuery}
                      queryName="getCustomerList"
                      keyName="status"
                      title="Supplier"
                    />
                    {/* )} */}
                  </CollapseCard>
                </div>

                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Suppliers">
                    {/* <h5 className="card-title">Suppliers</h5> */}

                    {/* <div id="columnChart"></div> */}
                    <LoaderSmall isLoading={supplierStatusColChartStatus} />
                    <h6>
                      {!supplierStatusColChartStatus ? (
                        <SuppliersColumnChart
                          key="supplier"
                          chartdata={supplierStatusColChart}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </CollapseCard>
                </div>

                {/* PO */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Purchase Requisition">
                    {/* <h5 className="card-title">Purchase Requisition</h5> */}
                    <LoaderSmall isLoading={prChartLoading} />
                    {!prChartLoading && (
                      <PurchaseRequisitionChart chartdata={prChartData} />
                    )}
                  </CollapseCard>
                </div>

                {/* RFX */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Request For Quotation">
                    {/* <h5 className="card-title">Request For Quotation</h5> */}
                    <LoaderSmall isLoading={loading} />
                    {!loading && <RfxColumnChart chartdata={chartData} />}
                  </CollapseCard>
                </div>

                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Purchase Order">
                    {/* <h5 className="card-title">Purchase Order</h5> */}
                    <LoaderSmall isLoading={poStatusColChartStatus} />
                    <h6>
                      {!poStatusColChartStatus ? (
                        <POColumnChart key="po" chartdata={poStatusColChart} />
                      ) : (
                        ""
                      )}
                    </h6>
                  </CollapseCard>
                </div>

                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <CollapseCard title="Procurement">
                    {/* <h5 className="card-title">Procurement</h5> */}
                    <div id="lineChart"></div>
                    <LineChart />
                  </CollapseCard>
                </div>

                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <CollapseCard title="Revenue">
                    {/* <h5 className="card-title">Revenue</h5> */}

                    <div id="areaChart"></div>
                    <AreaChart />
                  </CollapseCard>
                </div>

                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Country">
                    <h5 className="card-title">Country</h5>
                    <div id="barChart"></div>
                    <BarChart />
                  </CollapseCard>
                </div>

                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <CollapseCard title="Team">
                    {/* <h5 className="card-title">Team</h5> */}
                    <div id="pieChart"></div>
                    <PieChart />
                  </CollapseCard>
                </div>

                <div className="col-lg-6 commTopButtonRightLeftPadding">
                      <CollapseCard title="Team">
                      <h5 className="card-title">Team</h5>
                      <div id="donutChart"></div>
                      <DonutChart />
                   </CollapseCard>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Dashboard;
